<template>
  <div class="iconS">
    <div class="">{{ infoArray.title }}</div>
    <div>
      <van-field
        class="styInput"
        v-model="infoArray.number"
        :placeholder="infoArray.placeTitle"
        :type="inpType"
        @input="handleInput()"
      />
    </div>

    <div class="stybtn" v-if="infoArray.btnList && infoArray.btnList.length">
      <div class="stybtnleft">
        <div
          @click="handleSel(item)"
          :class="`styBtndefaul ${
            infoArray.isType == item.id ? 'styBtnActive' : ''
          }`"
          v-for="(item, index) in infoArray.btnList.slice(
            0,
            infoArray.btnList.length - 1
          )"
          :key="index"
        >
          {{ item.num }}
        </div>
      </div>

      <div
        @click="handleSel(infoArray.btnList.slice(-1)[0])"
        v-if="infoArray.isShowBtn"
        :class="`styBtndefaul ${
          infoArray.isType == infoArray.btnList.length ? 'styBtnActive' : ''
        }`"
      >
        {{ infoArray.btnList.slice(-1)[0].num }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComInput",
  props: {
    inpType: {
      type: String,
      default: "number",
    },
    infoArray: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },

  methods: {
    handleSel(item) {
      this.$emit("handleSel", item);
    },
    handleInput() {
      this.$emit("handleInput");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>